import { render, staticRenderFns } from "./FacilitiesWarning.vue?vue&type=template&id=674cf682&"
import script from "./FacilitiesWarning.vue?vue&type=script&lang=js&"
export * from "./FacilitiesWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports